<template>
    <i v-if="ticketEvent && ticketEvent.visible"
        class="el-icon-microphone ticket-event-visible-switch"
        @click="updateVisible(ticketEvent)"
        title="这是一条公开回复,点击可修改为私密的"/>
    <i v-else
        class="el-icon-turn-off-microphone ticket-event-visible-switch"
        @click="updateVisible(ticketEvent)"
        title="这是一条私密回复,对淘金客不可见,点击可修改为公开的"/>
</template>

<script>
export default {
    name: 'TicketEventVisibleSwitch',

    props: ['ticketEvent'],

    methods: {
        updateVisible(ticketEvent) {
            sdk.TicketEventApi().updateVisible({
                id: ticketEvent.flowId,
                visible: !ticketEvent.visible
            }).then(() => {
                _message("修改 " + ticketEvent.orderId + "#" + ticketEvent.flowId + " 为 " + ( ticketEvent.visible? "私密": "公开" ));

                ticketEvent.visible = !ticketEvent.visible;
            });
        }
    }
}
</script>

<style>
    .ticket-event-visible-switch:hover {
        cursor: pointer;
        box-shadow: 1px 1px 10px 5px #c4c4c4;
        transform:scale(1.5);
    }
</style>


// WEBPACK FOOTER //
// src/components/ticket/TicketEventVisibleSwitch.vue